<template>
    <div class="mobile-only">
        <slot />
    </div>
</template>